import * as React from 'react';

interface ParamSelectorProps<T> {
    title?: string,
    getValue: (e: T) => string,
    getSelected: (e: T) => boolean,
    options: T[],
    option_onClick: (e: T) => void
}

export default class ParamSelector<T> extends React.PureComponent<ParamSelectorProps<T>> {

    public render() {
        return (
            <div className='param-selector'>
                <div className='text-bold'>{this.props.title}</div>
                <div className='param-selector_params_wrapper'>
                    {this.props.options.map((element, index) => {
                        return <div key={index}
                            onClick={async () => await this.props.option_onClick(element)}
                            className={`${this.props.getSelected(element) && "selected"} param-selector_params_item text-norm`}>
                            {this.props.getValue(element)}
                        </div>
                    })}
                </div>
            </div>
        );
    }
}